import moment from 'moment'

import {
  IAPIHIInvoiceLine,
  IHIInvoiceLine,
} from '../interfaces/IHealthInsurance'

export const transformLineToAPILine = (
  data: IHIInvoiceLine,
): IAPIHIInvoiceLine => ({
  name: data.treatmentName,
  treatment_date: moment(data.treatmentDate).format('YYYY-MM-DD'),
  amount: data.amount,
  unit_price: data.unitPrice,
  discount: data.discount,
  vat_percentage: data.vatPercentage,
  line_total: data.lineTotal,
  person: {
    uuid: data.personUuid,
    value: data.personName,
    agb_code: data.personAgbCode,
  },
  activity: {
    uuid: data.treatmentUuid,
    value: data.treatmentName,
    treatment_code: data.treatmentCode,
  },
})
